module.exports = __webpack_public_path__ + "img/top-list-left4.32d6816b.png";